<template>
  <div
    style="position:relative;"
  >
    <table
      v-if="question.is_list_table"
      style="width: 100%;display: block;overflow-x: auto;white-space: nowrap;"
    >
      <thead>
        <tr>
          <th>
            &nbsp;
          </th>
          <th
            v-for="subfieldtype in fieldType.subfieldtypes"
            :key="subfieldtype.id"
          >
            <span v-html="subfieldtype.text"></span>
            <v-icon
              v-if="subfieldtype.required"
              size="10"
              color="red"
              style="vertical-align:middle;padding-left: 10px;"
            >
              mdi-asterisk
            </v-icon>
          </th>
        </tr>
      </thead>
      <Draggable
        v-model="answerList"
        tag="tbody"
        :options="{draggable:`.draggable-answerList-${question.id}`, handle:'.handle', animation: 150, easing: 'cubic-bezier(1, 0, 0, 1)'}"
        :move="drag"
        @end="endDrag"
      >
        <AnswerListTableRow
          v-for="(listId, answerIndex) in answerList"
          :key="listId.uuid || listId.id"
          :userFormId="userFormId"
          :question="question"
          :fieldType="fieldType"
          :listId.sync="answerList[answerIndex]"
          :colWidth="( 100 / fieldType.subfieldtypes.length )"
          @drop="$delete(answerList, answerIndex)"
          style="position:relative;"
          :class="`draggable-answerList-${question.id}`"
        />
      </Draggable>
    </table>
    <div v-else>
      <v-alert
        v-model="alertVisible"
        dismissible
        type="info"
        outline
      >
        This is a multi-answer field. For each answer, select "Add More".
      </v-alert>
      <AnswerListItem
        v-for="(listId, answerIndex) in answerList"
        :key="listId.uuid || listId.id"
        :userFormId="userFormId"
        :question="question"
        :fieldType="fieldType"
        :listId.sync="answerList[answerIndex]"
        @drop="$delete(answerList, answerIndex)"
      />
    </div>
    <v-btn
      :disabled="metMaxSize"
      small
      color="primary"
      style="color:white;margin-bottom:20px;"
      @click="answerList = answerList.concat([{id: null, uuid: $uuid.v1()}])"
    >
      <v-icon>add</v-icon>
      Add More<span v-if="question.max_rows">&nbsp;({{answerList.length}}/{{question.max_rows}})</span>
    </v-btn>
    <v-btn
      v-if="question.max_rows"
      disabled
      flat
      small
      style="color:white;margin-bottom:20px;"
    >
      This question is limited to {{question.max_rows}} rows
    </v-btn>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import AnswerListTableRow from './AnswerListTableRow'
import AnswerListItem from './AnswerListItem'
import Draggable from 'vuedraggable'

export default {
  name: 'AnswerList',
  props: [ 'userFormId', 'question', 'fieldType' ],
  components: { AnswerListTableRow, AnswerListItem, Draggable },
  data () {
    return {
      newanswer: { id: null },
      answerList: [],
      alertVisible: true,
      draggedElement: null
    }
  },
  created () {
    var answerListRows = JSON.parse(JSON.stringify(this.getAnswerList(this.question.id)))
    var defaultRows = this.question.default_rows
    while (defaultRows > 0 && answerListRows.length < this.question.default_rows) {
      answerListRows = answerListRows.concat([{id: null, uuid: this.$uuid.v1()}])
      defaultRows = defaultRows - 1
    }
    if (answerListRows.length === 0) {
      answerListRows = [{id: null, uuid: this.$uuid.v1()}]
    }
    this.answerList = answerListRows
  },
  computed: {
    ...mapGetters('userform', {
      getAnswerList: 'answerList'
    }),
    metMaxSize() {
      if (this.question.max_rows) {
        return this.answerList.length >= this.question.max_rows
      } else {
        return false
      }
    }
  },
  methods: {
    drag(e) {
      this.draggedElement = e.draggedContext.element
    },
    endDrag (event) {
      let movedPart = this.draggedElement
      this.draggedElement = null
      api.userform.userForm.moverow(this.userFormId, movedPart.id, event.newIndex)
    }
  }
}
</script>

<style scoped>
  table {
    table-layout: fixed;
    margin:auto;
    margin-top:15px;
    margin-bottom:15px;
  }
</style>